import React from 'react';
import bienvenido from '../../images/consejos-bam/bienvenido.png';

import ContainerStyled from './styles/WelcomeStyled';

const Welcome = () => {
  return (
    <ContainerStyled>
      <img src={bienvenido} alt="welcome title" />
    </ContainerStyled>
  );
};

export default Welcome;
